import * as accountApi from '@/network/api/accounts.api.js'
import * as beneficiariesApi from '@/network/api/transfers/beneficiaries.api.js'
import * as transfersApi from '@/network/api/transfers/transfers.api.js'
import * as recurringApi from '@/network/api/transfers/recurring.api.js'

/** Requests Accounts Balance
@return {promise} - Accounts Balance request
*/
export const requestAccountsBalances = async (context, payload) => {
    const res = await accountApi.requestAccountsBalances(payload)
    if (res) context.commit('SAVE_ACCOUNTS_BALANCE', res.data.data)

    return res
}

/** Requests Recurring Transfers
 @return {promise} - Recurring Transfers request
 */
export const requestRecurringTransfers = async (context, payload) => {
    const res = await recurringApi.requestRecurringTransfers(payload)
    if (res) context.commit('SAVE_RECURRING_TRANSFERS', { pageNumber: payload.pageNumber, data: res.data.data })

    return res
}

/** Requests Beneficiary Name
@return {promise} - Beneficiary Name request
*/
export const requestBeneficiaryName = async (context, payload) => {
    const res = await beneficiariesApi.getBeneficiaryDestinationInfo(payload)
    if (res) context.commit('SAVE_BENEFICIARY_NAME', res.data.data)

    return res
}

/** Requests Schedule Types
@return {promise} - Schedule Types request
*/
export const requestScheduleTypes = async (context) => {
    const res = await transfersApi.getTransfersScheduleTypes()
    if (res) context.commit('SAVE_SCHEDULE_TYPES', res.data.data)

    return res
}

/** Edit Recurring Transfer
@return {promise}
*/
export const editRecurringTransfer = async (context, payload) => {
    // payload: { accountId, transferId, data }
    const res = await recurringApi.editRecurringTransfer(payload)
    return res
}

/** Delete Recurring Transfers
@return {promise} -
*/
export const deleteRecurringTransfer = async (context, payload) => {
    const res = await recurringApi.deleteRecurringTransfer(payload)
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
